import { Box } from '@mui/material';
import { EmptyState } from '@orgnc/core/components/atoms';
import { IAcfArticleListProps } from '@orgnc/core/components/blocks/AcfArticleListBlock/AcfArticleListBlock';
import { RenderBlockProps } from '@orgnc/core/components/blocks/Blocks/helpers/RenderBlock';
import { SectionDivider } from '@orgnc/core/components/themes/Elements/components';
import {
  IAcfCategoryArticleListBlockFragment,
  IPostFragment,
} from '@orgnc/core/generated/graphql-operations';
import { BlockFragment } from '@orgnc/core/lib/wordpress/api/fragments/blocksFragment';
import MainArticleGridLayout from './ArticleList/MainArticleGridLayout';

const AcfCategoryArticleListBlock: React.FunctionComponent<
  RenderBlockProps
> = ({ block, frequency, area }) => {
  const renderBlock =
    block as unknown as BlockFragment<IAcfCategoryArticleListBlockFragment>;

  const posts = (renderBlock.categoryPosts as IPostFragment[]) ?? [];

  const LayoutComponent: React.FC<IAcfArticleListProps> =
    {
      'scriptmag-main-grid': MainArticleGridLayout,
    }[renderBlock.layout ?? ''] || MainArticleGridLayout;

  return (
    <Box
      data-og-block-area={area}
      data-og-block-nth={frequency}
      data-og-block-type="acf/categories-grid"
    >
      {renderBlock.includeSectionDivider !== '0' && <SectionDivider />}
      {posts.length > 0 ? (
        <div>
          <div data-type="latest-posts">
            <LayoutComponent
              excludeAuthorLink={false}
              excludeCategoryLink={false}
              hasImageLazyLoad={true}
              posts={posts}
            />
          </div>
        </div>
      ) : (
        <EmptyState title="No articles found" />
      )}
    </Box>
  );
};

export default AcfCategoryArticleListBlock;
